<template>
  <div
    class="AboutUs background-video w-background-video w-background-video-atom"
    style="display: contents; justify-content: space-between"
  >
    <video-background
      :src="require(`@/assets/transcode.mp4`)"
      :poster="require(`@/assets/dots.png`)"
      style="
        min-height: 90vh;
        display: flex;
        background-image: url('@/assets/dots.png');
        background-repeat: no-repeat;
        background-size: cover;
      "
    >
      <div class="overlay">
        <div class="row" style="display: flex; justify-content: space-between">
          <!-- <div
            class="col-md-5 text-light"
            data-aos="fade-right"
            data-aos-offset="200"
            data-aos-delay="50"
            data-aos-duration="1000"
            data-aos-easing="ease-in-out"
            data-aos-mirror="true"
            data-aos-once="false"
          >
            <div
              class="row"
              style="border-left-style: solid; border-left-color: #2c3e50"
            >
              <h4>Driver App</h4>
              <br />
              <p class="moto-text_normal" style="text-align: center">&nbsp;</p>
              <p class="moto-text_normal" style="text-align: center">&nbsp;</p>
              <div class="col-md-6 my-5">
                <a target="_blank" href="https://google.com"
                  ><img src="@/assets/playstore.png" width="60%"
                /></a>
              </div>
              <div class="col-md-6 my-5">
                <a target="_blank" href="https://google.com"
                  ><img src="@/assets/appstore.png" width="60%"
                /></a>
              </div>
            </div>
          </div> -->

          <div
            class="col-md-12 col-lg-12 col-sm-12"
            data-aos="fade-down"
            data-aos-offset="200"
            data-aos-delay="50"
            data-aos-duration="1000"
            data-aos-easing="ease-in-out"
            data-aos-mirror="true"
            data-aos-once="false"
          >
            <b-card
              id="card1"
              text-variant="light"
              class="text-center draw"
              style="
                border-radius: 0 !important;
                min-height: 90vh !important;
                display: flex;
              "
            >
              <template #header>
                <h2 class="display-9 my-3 font-weight-bold">
                  <b-icon class="animate1" icon="phone"></b-icon>
                </h2>
                <div class="dez-separator bg-primary"></div>
                <h4 class="mb-0 display-8 my-1 font-weight-bold">
                  Also You Can Get Our App!
                </h4>
              </template>
              <div
                class="row"
                style="display: flex; justify-content: space-between"
              >
                <div
                  class="col-md-6 col-lg-6 col-sm-6 col-xs-6 appstore"
                  data-aos="fade-right"
                  data-aos-offset="200"
                  data-aos-delay="50"
                  data-aos-duration="1000"
                  data-aos-easing="ease-in-out"
                  data-aos-mirror="true"
                  data-aos-once="false"
                >
                  <b-card-body>
                    <h2 class="display-9 my-3 font-weight-bold">
                      <img src="@/assets/playstoreicon.png" width="9%" />
                    </h2>
                    <div class="dez-separator1 bg-primary"></div>
                    <h4 class="mb-0 display-8 my-1 font-weight-bold">
                      On Play Store
                    </h4>
                    <b-card-text class="my-5">
                      <div
                        class="row"
                        style="display: flex; justify-content: space-between"
                      >
                        <div class="col-md-6">
                          <a href=""
                            ><h1>
                              <b-icon
                                class="animate1"
                                icon="phone"
                              ></b-icon></h1
                          ></a>
                          <h4>Driver App</h4>
                        </div>
                        <div class="col-md-6">
                          <a href=""
                            ><h1>
                              <b-icon
                                class="animate1"
                                icon="phone"
                              ></b-icon></h1
                          ></a>
                          <h4>Rider App</h4>
                        </div>
                      </div>
                    </b-card-text>
                  </b-card-body>
                </div>
                <div
                  class="col-md-6 col-lg-6 col-sm-6 col-xs-6 appstore"
                  data-aos="fade-left"
                  data-aos-offset="200"
                  data-aos-delay="50"
                  data-aos-duration="1000"
                  data-aos-easing="ease-in-out"
                  data-aos-mirror="true"
                  data-aos-once="false"
                >
                  <b-card-body>
                    <h2 class="display-9 my-3 font-weight-bold">
                      <img src="@/assets/appstoreicon.png" width="9%" />
                    </h2>
                    <div class="dez-separator1 bg-primary"></div>
                    <h4 class="mb-0 display-8 my-1 font-weight-bold">
                      On App Store
                    </h4>
                    <b-card-text class="my-5">
                      <div
                        class="row"
                        style="display: flex; justify-content: space-between"
                      >
                        <div class="col-md-6">
                          <a href=""
                            ><h1>
                              <b-icon
                                class="animate1"
                                icon="phone"
                              ></b-icon></h1
                          ></a>
                          <h4>Driver App</h4>
                        </div>
                        <div class="col-md-6">
                          <a href=""
                            ><h1>
                              <b-icon
                                class="animate1"
                                icon="phone"
                              ></b-icon></h1
                          ></a>
                          <h4>Rider App</h4>
                        </div>
                      </div>
                    </b-card-text>
                  </b-card-body>
                </div>
              </div>
            </b-card>
          </div>
        </div>
      </div>
    </video-background>
  </div>
</template>

<script>
export default {
  name: "AboutUs",
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.moto-text_normal {
  font-weight: 300;
  font-style: normal;
  font-family: "Raleway", sans-serif;
  color: #333333;
  font-size: 20px;
  line-height: 1.5;
  letter-spacing: 0px;
}
.w-background-video > video-background {
  background-size: cover;
  background-position: 50% 50%;
  position: absolute;
  margin: auto;
  width: 100%;
  height: 100%;
  right: -100%;
  bottom: -100%;
  top: -100%;
  left: -100%;
  object-fit: cover;
  z-index: -100;
}
.background-video {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  height: 100%;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  background-image: url("@/assets/dots.png");
  background-position: 50% 50%;
  background-size: 4px;
}
.w-background-video {
  position: relative;
  overflow: hidden;
  height: 500px;
  color: white;
}
audio,
canvas,
progress,
video {
  display: inline-block;
  vertical-align: baseline;
}
.w-background-video {
  position: relative;
  overflow: hidden;
  height: 500px;
  color: white;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url("@/assets/dots.png");
  background-size: 4px;
  opacity: 1 !important;
}
.MarketingBrief {
  /*background-color: #2c3e50;*/
  height: 90vh;
}
.animate1,
.animate2,
.animate3 {
  position: relative;
  top: 0;
  -moz-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
}
.animate11,
.animate22,
.animate33 {
  position: relative;
  top: 0;
  -moz-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
}
.draw {
  background-color: #1e2c3844;
  border: 1px;
  box-sizing: border-box;
  box-shadow: inset 0 0 0 2px transparent;
  font-size: inherit;
  position: relative;
  vertical-align: middle;
  -webkit-transition: width 0.25s ease-out, height 0.25s ease-out 0.25s;
  transition: width 0.25s ease-out, height 0.25s ease-out 0.25s;
}
.draw > div {
  position: relative;
  z-index: 1;
}
.draw:before,
.draw:after {
  box-sizing: inherit;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
}

.draw {
  -webkit-transition: color 0.25s;
  transition: color 0.25s;
}
.draw:before,
.draw:after {
  border: 2px solid transparent;
  width: 0;
  height: 0;
}
.draw:before {
  top: 0;
  left: 0;
}
.draw:after {
  bottom: 0;
  right: 0;
}

.dez-separator {
  display: inline-block;
  height: 3px;
  width: 50px;
  margin-bottom: 10px;
  position: relative;
}
.dez-separator1 {
  display: inline-block;
  height: 3px;
  width: 50px;
  margin-bottom: 10px;
  position: relative;
}
.dez-separator {
  -moz-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
}
.dez-separator1 {
  -moz-transition: all 0.5s;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
}
.bg-primary {
  background-color: #ffffff !important;
}
</style>
